import styled from 'styled-components'

export const TransparencyPageContainer = styled.div`
  min-height: 100vh;
  background: white;
`

export const TransparencyPageHeader = styled.div`
  /* Plain hybrid tokens now — no JS branch needed. --color-brand-deep and
     --color-brand-deep-2 each independently fall through to the exact static
     --vo-escuro/--vo-escuro-2 pair when the tenant has no primaryColor,
     reproducing today's gradient bit-for-bit; when one is set, both resolve
     to real darkenHex(primary, 0.75/0.6) shades instead. */
  background: linear-gradient(135deg, var(--color-brand-deep) 0%, var(--color-brand-deep-2) 100%);
  padding: 56px 24px 40px;
  text-align: center;
  position: relative;
  overflow: hidden;
`

export const TransparencyPageContent = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 24px 80px;
`

export const SectionTitle = styled.h2`
  font-family: 'Rubik', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--vo-ink);
  margin: 0 0 16px;
  letter-spacing: -.01em;
`
